import MainModal from '@/common/components/base/modal/Modal.tsx';
import { MainModalProps } from '@/common/components/base/modal/Modal.type.ts';
import { Box, Center } from 'styled-system/jsx';
import TitleDescription from '@/common/components/base/typography/TitleDescription.tsx';
import Typography from '@/common/components/base/typography/Typography.tsx';
import Button from '@/common/components/base/button/Button.tsx';
import RequestErrorIcon from '@/common/assets/icons/requestErrorIcon.svg?react';

export default ({
  open,
  closeModal,
  retryFunction,
}: MainModalProps & { retryFunction: () => void }) => {
  return (
    <MainModal open={open} closeModal={closeModal}>
      <NetworkErrorModal retryFunction={retryFunction} />
    </MainModal>
  );
};

const NetworkErrorModal = ({
  retryFunction,
}: {
  retryFunction: () => void;
}) => {
  return (
    <Box>
      <TitleDescription mb="1rem">خطا</TitleDescription>
      <Center mb="1.5rem">
        <RequestErrorIcon />
      </Center>
      <Typography mb="2rem" textStyle="b2">
        خطایی سمت سرور رخ داده است لطفا مجددا تلاش کنید
      </Typography>
      <Button mb="1rem" onClick={() => retryFunction()} fullWidth>
        تلاش مجدد
      </Button>
    </Box>
  );
};
